function initTheme() {

    const header = document.querySelector('.mega-header');

    window.addEventListener('scroll', () => {
        if (!header) return;
        if (window.scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }, { passive: true });

    const announcementSlides = document.querySelectorAll('.announcement-slide');
    let currentAnnouncementIndex = 0;

    if (announcementSlides.length > 1) {
        setInterval(() => {
            announcementSlides[currentAnnouncementIndex].classList.remove('active');
            currentAnnouncementIndex = (currentAnnouncementIndex + 1) % announcementSlides.length;
            announcementSlides[currentAnnouncementIndex].classList.add('active');
        }, 4000);
    }

    const slides = document.querySelectorAll('.slide');
    let currentSlideIndex = 0;
    let slideInterval;
    const SLIDE_DURATION = 6000;

    function goToSlide(index) {
        if (index === currentSlideIndex) return;
        slides[currentSlideIndex].classList.remove('active');
        currentSlideIndex = index;
        slides[currentSlideIndex].classList.add('active');
    }

    function nextSlide() {
        let nextIndex = (currentSlideIndex + 1) % slides.length;
        goToSlide(nextIndex);
    }

    function startSlideShow() {
        if (slideInterval) {
            clearInterval(slideInterval);
        }
        slideInterval = setInterval(nextSlide, SLIDE_DURATION);
    }

    if (slides.length > 1) {
        startSlideShow();
    }

    const hamburgerBtn = document.getElementById('hamburgerBtn');
    const mobileNavPanel = document.getElementById('mobileNavPanel');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const mobileNavClose = document.getElementById('mobileNavClose');

    function openMobileNav() {
        mobileNavPanel.classList.add('open');
        mobileNavOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
        mobileNavPanel.classList.remove('open');
        mobileNavOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    if (hamburgerBtn) hamburgerBtn.addEventListener('click', openMobileNav);
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
    if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

    function enableDragToScrollElement(slider) {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasDragged = false;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            hasDragged = false;
            slider.classList.add('active-drag');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            hasDragged = false;
            slider.classList.remove('active-drag');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            setTimeout(() => {
                hasDragged = false;
            }, 0);
            slider.classList.remove('active-drag');
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            if (Math.abs(x - startX) > 8) {
                hasDragged = true;
                e.preventDefault();
                slider.scrollLeft = scrollLeft - walk;
            }
        });

        slider.addEventListener('click', (e) => {
            if (hasDragged) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);
    }

    document.querySelectorAll('.hp-banner, .twilight-banner').forEach(banner => {
        banner.addEventListener('click', () => {
            banner.classList.toggle('banner-active');
        });
    });

    function initMoreToLoveCarousel(mtlTrack) {
        const mtlCards = mtlTrack.querySelectorAll('.mtl-product-wrapper, .mtl-card');
        if (mtlCards.length === 0) return;
        let isTransitioning = false;

        function updateActiveCard() {
            const currentCards = mtlTrack.querySelectorAll('.mtl-product-wrapper, .mtl-card');
            currentCards.forEach(card => card.classList.remove('active'));
            let activeIdx = window.innerWidth <= 768 ? 1 : 2;
            if (currentCards.length > activeIdx) {
                currentCards[activeIdx].classList.add('active');
            } else {
                currentCards[0].classList.add('active');
            }
        }

        updateActiveCard();
        window.addEventListener('resize', updateActiveCard);

        function moveNext() {
            if (isTransitioning) return;
            isTransitioning = true;

            const currentCards = mtlTrack.querySelectorAll('.mtl-product-wrapper, .mtl-card');
            const cardWidth = currentCards[0].offsetWidth + 30;

            mtlTrack.style.transition = 'transform 0.5s ease-in-out';
            mtlTrack.style.transform = `translateX(-${cardWidth}px)`;

            currentCards.forEach(card => card.classList.remove('active'));
            let nextActiveIdx = window.innerWidth <= 768 ? 2 : 3;
            if (currentCards.length > nextActiveIdx) {
                currentCards[nextActiveIdx].classList.add('active');
            }

            setTimeout(() => {
                mtlTrack.style.transition = 'none';
                mtlTrack.style.transform = 'translateX(0)';
                mtlTrack.appendChild(currentCards[0]);
                isTransitioning = false;
            }, 500);
        }

        let mtlInterval = setInterval(moveNext, 3500);

        let touchStartX = 0;
        mtlTrack.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
        mtlTrack.addEventListener('touchend', e => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (diff > 50) {
                clearInterval(mtlInterval);
                moveNext();
                mtlInterval = setInterval(moveNext, 3500);
            }
        }, { passive: true });
    }

    function initAutoSliderElement(track, itemSelector, intervalMs, dotsSelector = null, mobileOnly = false) {
        let items = Array.from(track.querySelectorAll(itemSelector));
        if (mobileOnly) {
            items = items.filter(item => !item.classList.contains('desktop-only'));
        }
        if (items.length <= 1) return;

        let currentIndex = 0;
        let sliderInterval;
        let dotsContainer = null;
        if (dotsSelector) {

            dotsContainer = track.parentElement.querySelector(dotsSelector) || document.querySelector(dotsSelector);
        }

        if (dotsContainer) {
            dotsContainer.innerHTML = '';
            items.forEach((_, i) => {
                const dot = document.createElement('span');
                dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
                dotsContainer.appendChild(dot);

                dot.addEventListener('click', () => {
                    currentIndex = i;
                    scrollToCurrent();
                    resetInterval();
                });
            });
        }

        function getTrackGap() {
            if (track._cachedGap !== undefined) return track._cachedGap;
            track._cachedGap = parseFloat(window.getComputedStyle(track).gap) || 0;
            return track._cachedGap;
        }

        function scrollToCurrent() {
            if (items.length === 0) return;
            const itemWidth = items[0].offsetWidth;
            const gap = getTrackGap();
            const scrollPos = currentIndex * (itemWidth + gap);

            track.scrollTo({ left: scrollPos, behavior: 'smooth' });

            if (dotsContainer) {
                const dots = dotsContainer.querySelectorAll('.slider-dot');
                dots.forEach((dot, i) => {
                    dot.classList.toggle('active', i === currentIndex);
                });
            }
        }

        function updateSlider() {
            if (mobileOnly && window.innerWidth > 768) {
                if (sliderInterval) {
                    clearInterval(sliderInterval);
                    sliderInterval = null;
                }
                return;
            }
            currentIndex = (currentIndex + 1) % items.length;
            scrollToCurrent();
        }

        function startSlider() {
            if (!sliderInterval) {
                sliderInterval = setInterval(updateSlider, intervalMs);
            }
        }

        function resetInterval() {
            if (sliderInterval) {
                clearInterval(sliderInterval);
                startSlider();
            }
        }

        if (!mobileOnly || window.innerWidth <= 768) {
            startSlider();
        }

        window.addEventListener('resize', () => {
            delete track._cachedGap;
            if (mobileOnly) {
                if (window.innerWidth <= 768) startSlider();
                else {
                    if (sliderInterval) clearInterval(sliderInterval);
                    sliderInterval = null;
                }
            }
        });

        track.addEventListener('scroll', () => {
            if (mobileOnly && window.innerWidth > 768) return;
            const itemWidth = items[0].offsetWidth;
            const gap = getTrackGap();
            const scrollLeft = track.scrollLeft;
            currentIndex = Math.round(scrollLeft / (itemWidth + gap));

            if (dotsContainer) {
                const dots = dotsContainer.querySelectorAll('.slider-dot');
                dots.forEach((dot, i) => {
                    dot.classList.toggle('active', i === currentIndex);
                });
            }
        }, { passive: true });
    }

    function lazyInit(selector, initCallback) {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        initCallback(entry.target);
                        obs.unobserve(entry.target);
                    }
                });
            }, { rootMargin: '100px' });
            document.querySelectorAll(selector).forEach(el => observer.observe(el));
        } else {
            document.querySelectorAll(selector).forEach(el => initCallback(el));
        }
    }

    lazyInit('.pslider-track, .curate-grid, .sheglam-mtl-track', (track) => {
        enableDragToScrollElement(track);
    });

    lazyInit('.worth-hype-products', (track) => {
        enableDragToScrollElement(track);
        initAutoSliderElement(track, '.wth-card-new', 2000, '.wth-slider-dots', true);
    });

    lazyInit('.reviews-slider-track', (track) => {
        enableDragToScrollElement(track);
        initAutoSliderElement(track, '.review-item', 2000, '.reviews-dots', false);
    });

    lazyInit('.core-values-grid', (track) => {
        initAutoSliderElement(track, '.value-item', 2000, '.values-dots', false);
    });

    lazyInit('.mtl-track', (track) => {
        initMoreToLoveCarousel(track);
    });

    function initDynamicProductHighlights() {
        const highlightDataset = {
            "Moisturizing Matte Lipstick - 4.2g": ["SMUDGE-PROOF", "LONG-LASTING", "RICH PIGMENT", "COMFORTABLE WEAR"],
            "3 Ultra Soft Matte Lipstick Kit + Free Waterproof Eyeliner": ["ULTRA SOFT FINISH", "LONG-LASTING COLOR", "WATERPROOF EYELINER", "EVERYDAY GLAM"],
            "4 Glamorous Lipstick Kit - SPF 25 + FREE Waterproof Eyeliner": ["SPF 25 PROTECTION", "RICH COLOR PAYOFF", "WATERPROOF EYELINER", "SMOOTH APPLICATION"],
            "4 Trending Liquid Lipstick Kit": ["TRENDY SHADES", "SMUDGE-PROOF", "LONG WEAR", "LIGHTWEIGHT FORMULA"],
            "4 Must-Have Liquid Lipstick Kit": ["HIGHLY PIGMENTED", "NON-DRYING", "LONG-LASTING", "SMOOTH FINISH"],
            "Pack of 4 Hydrating & High Shine Lip Glosses": ["HIGH SHINE FINISH", "HYDRATING FORMULA", "NON-STICKY FEEL", "EVERYDAY WEAR"],
            "Lips Moisturizing Balm BM": ["DEEP HYDRATION", "SOFT LIPS", "DAILY CARE", "NON-STICKY FORMULA"],
            "3 Glittery Coloured Eyeliners Kit": ["VIBRANT COLORS", "GLITTER EFFECT", "LONG WEAR", "EASY GLIDE"],
            "Combo Pack Of Eyeliner & Kajal": ["INTENSE BLACK", "SMOOTH APPLICATION", "LONG-LASTING", "EYE DEFINING LOOK"],
            "Most Loved Eyeshadow Palette": ["HIGHLY PIGMENTED", "BLENDABLE SHADES", "SMOOTH TEXTURE", "VERSATILE LOOKS"],
            "MRZ Coloured Glitter Eyeliner": ["SPARKLING FINISH", "BOLD COLORS", "EASY APPLICATION", "LONG WEAR"],
            "Pack Of 9 Eyeshadows": ["9 STUNNING SHADES", "EASY BLENDING", "RICH PIGMENT", "DAY TO NIGHT LOOKS"],
            "4 Stunning Eyeshadows Combo + Free Eyeliner": ["RICH COLOR PAYOFF", "EASY BLENDING", "COMPLETE EYE LOOK", "FREE EYELINER"],
            "Pop Colored Eyeliner Pack": ["POP COLORS", "SMUDGE RESISTANT", "SMOOTH GLIDE", "CREATIVE LOOKS"],
            "Colored Eyeliner": ["VIBRANT SHADES", "PRECISION APPLICATION", "LONG WEAR", "EYE-CATCHING FINISH"],
            "FREE Eyeliner": ["INTENSE COLOR", "SMOOTH GLIDE", "EASY APPLICATION", "LONG WEAR"],
            "10 Hour Long-Stay Intense Kajal": ["10 HOUR WEAR", "INTENSE BLACK", "SMUDGE RESISTANT", "SMOOTH GLIDE"],
            "Matte Silky Touch Compact Powder": ["SILKY SMOOTH FINISH", "LIGHTWEIGHT FEEL", "NATURAL COVERAGE", "SHINE CONTROL"],
            "Men Activated Charcoal Face Wash": ["DEEP CLEANSING", "OIL CONTROL", "REMOVES IMPURITIES", "REFRESHING FEEL"],
            "Men Activated Charcoal Face Scrub": ["GENTLE EXFOLIATION", "UNCLOGS PORES", "REMOVES DEAD SKIN", "FRESH LOOK"],
            "After Shave Balm with Fitkari": ["SOOTHES SKIN", "REDUCES IRRITATION", "COOLING EFFECT", "HYDRATING CARE"],
            "Jade Roller - Face Massager Tool": ["IMPROVES CIRCULATION", "REDUCES PUFFINESS", "RELAXING MASSAGE", "HEALTHY GLOW"],
            "Moraze Combo of Men Face Wash and Face Scrub": ["DEEP CLEANSE", "OIL CONTROL", "EXFOLIATING CARE", "DAILY GROOMING"],
            "Blush Brush": ["SOFT BRISTLES", "EVEN BLENDING", "SMOOTH APPLICATION", "PROFESSIONAL FINISH"],
            "Highlighter Brush": ["PRECISION APPLICATION", "SOFT BRISTLES", "NATURAL GLOW", "EASY BLENDING"],
            "Foundation Brush": ["STREAK-FREE FINISH", "SMOOTH COVERAGE", "SOFT BRISTLES", "EASY APPLICATION"],
            "Glow Essentials Combo": ["COMPLETE SKINCARE", "DEEP CLEANSING", "HEALTHY GLOW", "DAILY CARE"],
            "Face Serum For All Your Skin Concerns + FREE Face Roller": ["DEEP HYDRATION", "HEALTHY GLOW", "LIGHTWEIGHT FORMULA", "FREE FACE ROLLER"],
            "Mens Combo Kit - Face Wash, Face Scrub & Lipcare": ["COMPLETE GROOMING", "DEEP CLEANSING", "LIP CARE SUPPORT", "EVERYDAY FRESHNESS"],
            "Moraze Men Activated Charcoal Pollution & Oil Control Face Scrub & Face Wash": ["POLLUTION DEFENSE", "OIL CONTROL", "DEEP CLEANSING", "HEALTHY LOOKING SKIN"],
            "Men Activated Charcoal Face Wash - 100ML BM": ["CHARCOAL POWER", "DEEP CLEANSE", "OIL CONTROL", "REFRESHING FEEL"],
            "5 Glamorous Nail Polish Kit": ["RICH COLOR PAYOFF", "GLOSSY FINISH", "SMOOTH APPLICATION", "LONG WEAR"],
            "Neon Pack Of 6 Nail Polish With Top Coat": ["VIBRANT NEON SHADES", "EXTRA GLOSS FINISH", "QUICK DRY FORMULA", "LONG LASTING WEAR"],
            "Moraze Mini Nail Polish Pack of 24": ["24 TRENDY SHADES", "HIGH PIGMENTATION", "SMOOTH APPLICATION", "CREATIVE NAIL LOOKS"],
            "Moraze Mini Nail Polish Pack of 12": ["12 STUNNING SHADES", "GLOSSY FINISH", "EASY APPLICATION", "EVERYDAY STYLE"],
            "Moraze 5 Trending Nail Polish Kit": ["TRENDING COLORS", "HIGH SHINE FINISH", "SMOOTH GLIDE", "LONG WEAR"],
            "Nail Paint Pack – 10 Highly Glossy Pigmented Shades": ["10 VIBRANT SHADES", "HIGHLY PIGMENTED", "ULTRA GLOSSY FINISH", "SMOOTH APPLICATION"],
            "4 Glamorous Glossy Nail Polish Kit + FREE Top Coat": ["HIGH GLOSS FINISH", "LONG LASTING WEAR", "SMOOTH APPLICATION", "FREE TOP COAT"],
            "Luxury Body Perfumes Pack of 4": ["LONG LASTING FRAGRANCE", "PREMIUM SCENT COLLECTION", "EVERYDAY LUXURY", "TRAVEL FRIENDLY"],
            "Long Lasting Pack of 6 Perfume Set": ["6 UNIQUE FRAGRANCES", "LONG LASTING AROMA", "PREMIUM BLEND", "PERFECT FOR EVERY MOOD"],
            "Unisex Perfume - 10ML": ["FRESH FRAGRANCE", "LONG LASTING WEAR", "COMPACT & PORTABLE", "EVERYDAY ESSENTIAL"],
            "Intense Perfume For Men": ["BOLD MASCULINE SCENT", "LONG LASTING PERFORMANCE", "PREMIUM FRAGRANCE", "CONFIDENT PRESENCE"],
            "Rare Perfume For Men": ["UNIQUE FRAGRANCE PROFILE", "LONG LASTING AROMA", "PREMIUM QUALITY", "SIGNATURE SCENT"],
            "Crystal Perfume For Women": ["ELEGANT FLORAL NOTES", "LONG LASTING FRAGRANCE", "SOPHISTICATED SCENT", "EVERYDAY LUXURY"],
            "Desire Perfume For Women": ["CAPTIVATING FRAGRANCE", "LONG LASTING WEAR", "PREMIUM BLEND", "FEMININE ELEGANCE"],
            "Refreshing Body Mist Kit": ["INSTANT FRESHNESS", "LIGHT FRAGRANCE", "DAILY REFRESH", "EASY TO CARRY"],
            "Mini Pocket Perfume Pack of 2": ["POCKET FRIENDLY", "LONG LASTING AROMA", "TRAVEL READY", "EVERYDAY USE"]
        };

        function generateDynamicUSPs(title) {
            const lowerTitle = title.toLowerCase();
            if (lowerTitle.includes('lipstick') || lowerTitle.includes('lip gloss') || lowerTitle.includes('lip-gloss') || lowerTitle.includes('lip play') || lowerTitle.includes('lip tint') || lowerTitle.includes('lip crayon') || lowerTitle.includes('liquid lip') || lowerTitle.includes('lip color') || lowerTitle.includes('lip colour') || lowerTitle.includes('matte lip')) {
                return ["RICH COLOR PAYOFF", "SMUDGE-PROOF FINISH", "HYDRATING FORMULA", "ALL-DAY COMFORT WEAR"];
            } else if (lowerTitle.includes('eyeliner') || lowerTitle.includes('kajal') || lowerTitle.includes('mascara') || lowerTitle.includes('eyeshadow') || lowerTitle.includes('eye shadow') || lowerTitle.includes('palette') || lowerTitle.includes('brow') || lowerTitle.includes('lash') || lowerTitle.includes('eye')) {
                return ["INTENSE PIGMENT", "WATERPROOF FORMULA", "SMUDGE-PROOF WEAR", "ALL-DAY DEFINITION"];
            } else if (lowerTitle.includes('nail')) {
                return ["HIGH-SHINE FINISH", "CHIP-RESISTANT", "QUICK DRY FORMULA", "LONG-LASTING COLOR"];
            } else if (lowerTitle.includes('face wash') || lowerTitle.includes('facewash') || lowerTitle.includes('cleanser') || lowerTitle.includes('scrub') || lowerTitle.includes('exfoliator') || lowerTitle.includes('peel')) {
                return ["DEEP PORE CLEANSING", "OIL & SEBUM CONTROL", "REMOVES IMPURITIES", "REFRESHING SKIN FEEL"];
            } else if (lowerTitle.includes('serum') || lowerTitle.includes('essence') || lowerTitle.includes('oil') || lowerTitle.includes('elixir') || lowerTitle.includes('brightening')) {
                return ["DEEP SKIN HYDRATION", "BRIGHTENS DULL SKIN", "LIGHTWEIGHT ABSORPTION", "RESTORES NATURAL GLOW"];
            } else if (lowerTitle.includes('perfume') || lowerTitle.includes('mist') || lowerTitle.includes('spray') || lowerTitle.includes('fragrance') || lowerTitle.includes('cologne') || lowerTitle.includes('deodorant') || lowerTitle.includes('scent')) {
                return ["LONG-LASTING FRAGRANCE", "PREMIUM SCENT PROFILE", "ELEGANT & LUXURIOUS", "PERFECT FOR EVERYDAY"];
            } else if (lowerTitle.includes('moisturizer') || lowerTitle.includes('cream') || lowerTitle.includes('lotion') || lowerTitle.includes('balm') || lowerTitle.includes('sunscreen') || lowerTitle.includes('spf') || lowerTitle.includes('hydrator') || lowerTitle.includes('lip')) {
                return ["INTENSE HYDRATION", "BARRIER PROTECTION", "NON-GREASY FORMULA", "SOFT & SUPPLE SKIN"];
            } else if (lowerTitle.includes('brush') || lowerTitle.includes('applicator') || lowerTitle.includes('blender') || lowerTitle.includes('tool') || lowerTitle.includes('roller') || lowerTitle.includes('massager')) {
                return ["PRESTIGE SOFT BRISTLES", "FLAWLESS APPLICATION", "EVEN PRODUCT BLENDING", "PROFESSIONAL DESIGN"];
            } else {
                return ["HIGH-PERFORMANCE", "DERMATOLOGICALLY TESTED", "CRUELTY-FREE FORMULA", "SUITABLE FOR ALL SKIN TYPES"];
            }
        }

        const cards = document.querySelectorAll('.ag-product-card, .moraze-london-card');
        cards.forEach(card => {
            const rawTitle = card.getAttribute('data-product-title') || card.querySelector('.ag-product-title, .product-title-block')?.textContent?.trim();
            if (!rawTitle) return;

            let matchedHighlights = null;
            const searchTitle = rawTitle.toLowerCase().trim();

            for (const key in highlightDataset) {
                if (searchTitle === key.toLowerCase().trim()) {
                    matchedHighlights = highlightDataset[key];
                    break;
                }
            }

            if (!matchedHighlights) {
                for (const key in highlightDataset) {
                    if (searchTitle.includes(key.toLowerCase().trim()) || key.toLowerCase().trim().includes(searchTitle)) {
                        matchedHighlights = highlightDataset[key];
                        break;
                    }
                }
            }

            if (!matchedHighlights) {
                matchedHighlights = generateDynamicUSPs(rawTitle);
            }

            const bar = card.querySelector('.ag-feature-bar, .dewy-glow-bar');
            if (matchedHighlights && matchedHighlights.length > 0) {
                const scroller = card.querySelector('.ag-feature-scroller');
                if (scroller) {
                    scroller.innerHTML = '';
                    scroller.classList.remove('ag-scroll-3', 'ag-scroll-4', 'ag-scroll-5');
                    scroller.classList.add(`ag-scroll-${matchedHighlights.length}`);

                    matchedHighlights.forEach(word => {
                        const wordDiv = document.createElement('div');
                        wordDiv.className = 'ag-feature-word';
                        wordDiv.textContent = word;
                        scroller.appendChild(wordDiv);
                    });
                }
                if (bar) {
                    bar.style.display = '';
                }
            } else {
                if (bar) {
                    bar.style.display = 'none';
                }
            }
        });
    }

    // ponytail: defer non-critical product card USP badges and review observers to requestIdleCallback
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(function () {
            initDynamicProductHighlights();
            initTrustooCardsObserver();
        }, { timeout: 3000 });
    } else {
        setTimeout(function () {
            initDynamicProductHighlights();
            initTrustooCardsObserver();
        }, 150);
    }
}

window.populateCartDeals = function () {
    const dealsTemplate = document.getElementById('CartDrawerDealsTemplate');
    const dealsContainer = document.getElementById('CartDrawerDealsContainer');
    if (dealsTemplate && dealsContainer) {
        dealsContainer.innerHTML = '';
        dealsContainer.appendChild(dealsTemplate.content.cloneNode(true));
    }
};

window.openCartDrawer = function () {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('open');
    document.body.classList.add('cart-drawer-open');
    document.body.style.overflow = 'hidden';

    if (typeof window.populateCartDeals === 'function') {
        window.populateCartDeals();
    }

    if (typeof window.checkCartMilestones === 'function') {
        window.checkCartMilestones();
    }
};

window.closeCartDrawer = function () {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.remove('open');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';
};

window.updateCartDrawer = function () {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    activeCartFetches++;
    window.mzOptimisticCartUpdate();

    return fetch(rootUrl + '?section_id=cart-drawer&t=' + Date.now())
        .then(res => res.text())
        .then(text => {
            const temp = document.createElement('div');
            temp.innerHTML = text;

            const newContent = temp.querySelector('.cart-drawer__content');
            const currentContent = document.querySelector('.cart-drawer__content');
            if (newContent && currentContent) {
                currentContent.innerHTML = newContent.innerHTML;
            }

            if (typeof window.populateCartDeals === 'function') {
                window.populateCartDeals();
            }

            fetch(rootUrl + 'cart.js')
                .then(r => r.json())
                .then(cart => {
                    const badge = document.querySelector('.mz-cart-count');
                    if (badge) {
                        badge.textContent = Math.max(0, cart.item_count);
                        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
                    }
                    const fcbCount = document.getElementById('fcb-item-count');
                    if (fcbCount) {
                        fcbCount.textContent = cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');
                    }
                })
                .catch(() => { });

            document.dispatchEvent(new CustomEvent('cart-drawer:updated'));
        })
        .catch(e => {
            console.error('Error updating cart:', e);
            cartUpdateError = "Couldn't update cart, please try again";
        })
        .finally(() => {
            activeCartFetches--;
            window.mzOptimisticCartUpdate();
        });
};

const cartUpdateTimeouts = {};
const pendingQuantities = {};
let activeCartFetches = 0;
let cartUpdateError = null;

function getProgressPct(cartTotal, freeShippingThreshold, milestones) {
    if (milestones.length === 0) {
        return cartTotal >= freeShippingThreshold ? 100 : (cartTotal / freeShippingThreshold * 100);
    }

    const maxThreshold = Math.max(freeShippingThreshold, ...milestones.map(m => m.threshold));
    const nodeCount = milestones.length + 1;
    const segmentPct = 100 / nodeCount;

    if (cartTotal >= maxThreshold) {
        return 100;
    }

    if (cartTotal < freeShippingThreshold) {
        return (cartTotal / freeShippingThreshold) * segmentPct;
    }

    let mzProgressPct = 0;
    let prevThreshold = freeShippingThreshold;
    for (let i = 0; i < milestones.length; i++) {
        const blkThreshold = milestones[i].threshold;
        if (cartTotal < blkThreshold && mzProgressPct === 0) {
            const segRange = blkThreshold - prevThreshold;
            const segFill = ((cartTotal - prevThreshold) / segRange) * segmentPct;
            const segBase = (i + 1) * segmentPct;
            mzProgressPct = segBase + segFill;
        }
        prevThreshold = blkThreshold;
    }
    return mzProgressPct || 100;
}

function updateMilestoneProgressUI(cartTotal, freeShippingThreshold) {
    const milestonesEl = document.getElementById('mz-milestones-data');
    if (!milestonesEl) return;

    let milestonesData;
    try {
        milestonesData = JSON.parse(milestonesEl.textContent);
    } catch (e) {
        console.error('[Moraze] Error parsing milestones data for optimistic UI:', e);
        return;
    }

    const milestones = milestonesData.milestones || [];
    const maxThreshold = Math.max(freeShippingThreshold, ...milestones.map(m => m.threshold));
    const allUnlocked = cartTotal >= maxThreshold;

    const progressPct = getProgressPct(cartTotal, freeShippingThreshold, milestones);
    const progressFill = document.querySelector('.cd-progress-fill');
    if (progressFill) {
        progressFill.style.width = Math.round(progressPct) + '%';
    }

    const shippingNode = document.querySelector('.cd-progress-nodes > .cd-node:first-child');
    if (shippingNode) {
        const isDone = cartTotal >= freeShippingThreshold;
        shippingNode.classList.toggle('cd-node--done', isDone);
        const circle = shippingNode.querySelector('.cd-node-circle');
        if (circle) circle.classList.toggle('cd-node-circle--active', isDone);
        const label = shippingNode.querySelector('span');
        if (label) label.classList.toggle('cd-node-label--active', isDone);
    }

    let nextLabel = '';
    let nextAmount = 0;

    if (cartTotal < freeShippingThreshold) {
        nextLabel = 'Free Shipping';
        nextAmount = freeShippingThreshold - cartTotal;
    }

    const itemRows = document.querySelectorAll('.cd-item');

    milestones.forEach((milestone, idx) => {
        const node = document.querySelector(`.cd-node[data-milestone-index="${idx}"]`);
        const threshold = milestone.threshold;
        const isDone = cartTotal >= threshold;

        if (cartTotal < threshold && nextLabel === '') {
            nextLabel = milestone.label || 'Free Gift';
            nextAmount = threshold - cartTotal;
        }

        if (node) {
            node.classList.toggle('cd-node--done', isDone);
            const circle = node.querySelector('.cd-node-circle');
            if (circle) circle.classList.toggle('cd-node-circle--active', isDone);
            const label = node.querySelector('span');
            if (label) label.classList.toggle('cd-node-label--active', isDone);

            let btn = node.querySelector('.claim-gift-btn');
            let status = node.querySelector('.claim-gift-status');

            const giftInCart = Array.from(itemRows).some(row => {
                const key = row.getAttribute('data-key') || '';
                const isFreeGift = row.getAttribute('data-is-free-gift') === 'true';
                let qty = 0;
                if (pendingQuantities.hasOwnProperty(key)) {
                    qty = pendingQuantities[key];
                } else {
                    const qtyValEl = row.querySelector('.cd-qty-val');
                    if (qtyValEl) qty = parseInt(qtyValEl.textContent.trim(), 10) || 0;
                }
                return key.startsWith(milestone.variantId.toString()) && isFreeGift && qty > 0;
            });

            if (isDone) {
                if (giftInCart) {
                    if (btn) btn.remove();
                    if (!status) {
                        status = document.createElement('span');
                        status.className = 'claim-gift-status';
                        status.style.cssText = 'font-size:0.55rem; color:#2E7D32; font-weight:700; margin-top:2px;';
                        status.textContent = 'Added';
                        node.appendChild(status);
                    }
                } else {
                    if (status) status.remove();
                    if (!btn) {
                        btn = document.createElement('button');
                        btn.type = 'button';
                        btn.className = 'claim-gift-btn';
                        btn.setAttribute('onclick', `claimMilestoneGift(${idx}, this); event.stopPropagation();`);
                        btn.textContent = 'Claim';
                        node.appendChild(btn);
                    }
                }
            } else {
                if (btn) btn.remove();
                if (status) status.remove();
            }
        }
    });

    const progressMsgEl = document.querySelector('.cd-progress-msg');
    if (progressMsgEl) {
        if (allUnlocked) {
            progressMsgEl.className = 'cd-progress-msg cd-progress-msg--success';
            progressMsgEl.innerHTML = '🎉 <strong>Congrats! You have unlocked all free gifts!</strong>';
        } else if (cartTotal < freeShippingThreshold) {
            progressMsgEl.className = 'cd-progress-msg';
            progressMsgEl.innerHTML = `Add ₹${Math.ceil(freeShippingThreshold - cartTotal)} more for Free Shipping`;
        } else {
            progressMsgEl.className = 'cd-progress-msg cd-progress-msg--success';
            progressMsgEl.innerHTML = `🎁 Add ₹${Math.ceil(nextAmount)} more to unlock ${nextLabel}!`;
        }
    }
}

window.mzOptimisticCartUpdate = function () {
    const items = document.querySelectorAll('.cd-item');

    let totalCents = 0;
    let originalTotalCents = 0;
    let promoTotalCents = 0;
    let regularItemsCount = 0;
    let totalItemsCount = 0;

    let freeShippingThreshold = 399;
    const shippingSpan = document.querySelector('.js-cd-shipping');
    if (shippingSpan) {
        const thresholdAttr = shippingSpan.getAttribute('data-threshold');
        if (thresholdAttr) {
            freeShippingThreshold = parseFloat(thresholdAttr);
        }
    }

    items.forEach(item => {
        const key = item.getAttribute('data-key');
        const priceVal = parseFloat(item.getAttribute('data-price') || '0');
        const origPriceVal = parseFloat(item.getAttribute('data-original-price') || '0');
        const isFreeGift = item.getAttribute('data-is-free-gift') === 'true';

        let qty = 0;
        if (pendingQuantities.hasOwnProperty(key)) {
            qty = pendingQuantities[key];
        } else {
            const qtyValEl = item.querySelector('.cd-qty-val');
            if (qtyValEl) {
                qty = parseInt(qtyValEl.textContent.trim(), 10) || 0;
            }
        }

        if (qty <= 0) {
            return;
        }

        totalItemsCount += qty;

        if (isFreeGift) {
            originalTotalCents += origPriceVal * qty;
        } else {
            regularItemsCount += qty;
            totalCents += priceVal * qty;
            originalTotalCents += origPriceVal * qty;
            promoTotalCents += priceVal * qty;
        }
    });

    function formatCents(cents) {
        const symbol = (window.themeCurrency && window.themeCurrency.symbol) ? window.themeCurrency.symbol : '₹';
        const isoCode = (window.themeCurrency && window.themeCurrency.isoCode) ? window.themeCurrency.isoCode : 'INR';
        const dollars = cents / 100;
        if (isoCode === 'INR') {
            const rupees = Math.round(dollars);
            return symbol + rupees.toLocaleString('en-IN');
        }
        return symbol + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const checkoutBtn = document.querySelector('.cd-checkout-btn');
    const hasPendingUpdates = Object.keys(cartUpdateTimeouts).length > 0 || activeCartFetches > 0;
    if (checkoutBtn) {
        if (hasPendingUpdates) {
            checkoutBtn.classList.add('btn-loading');
            checkoutBtn.style.pointerEvents = 'none';
            checkoutBtn.style.opacity = '0.7';
            if (!checkoutBtn.getAttribute('data-orig-text')) {
                checkoutBtn.setAttribute('data-orig-text', checkoutBtn.innerHTML);
            }
            checkoutBtn.innerHTML = 'Updating...';
        } else if (cartUpdateError) {
            checkoutBtn.classList.remove('btn-loading');
            checkoutBtn.style.pointerEvents = '';
            checkoutBtn.style.opacity = '';
            checkoutBtn.innerHTML = cartUpdateError;
        } else {
            checkoutBtn.classList.remove('btn-loading');
            checkoutBtn.style.pointerEvents = '';
            checkoutBtn.style.opacity = '';
            const origText = checkoutBtn.getAttribute('data-orig-text');
            if (origText) {
                checkoutBtn.innerHTML = origText;
                checkoutBtn.removeAttribute('data-orig-text');
            }
        }
    }

    const effectivelyEmpty = (regularItemsCount === 0);

    if (effectivelyEmpty) {

        items.forEach(item => {
            const isFreeGift = item.getAttribute('data-is-free-gift') === 'true';
            if (isFreeGift) {
                item.style.transition = 'opacity 0.2s ease-out';
                item.style.opacity = '0';
                setTimeout(() => { item.style.display = 'none'; }, 200);
            }
        });

        const progressSection = document.querySelector('.cd-progress-section');
        const detailsHeader = document.querySelector('.cd-details-header');
        if (progressSection) progressSection.style.display = '';
        if (detailsHeader) detailsHeader.style.display = '';

        const headerCount = document.querySelector('.cd-item-count');
        if (headerCount) headerCount.textContent = '0 Items';

        const emptyState = document.querySelector('.cd-empty-state');
        const priceSummary = document.querySelector('.cd-price-summary');
        const footer = document.querySelector('.cd-footer');
        if (emptyState) emptyState.style.display = 'block';
        if (priceSummary) priceSummary.style.display = 'none';
        if (footer) footer.style.display = 'none';

        updateMilestoneProgressUI(0, freeShippingThreshold);

        const badge = document.querySelector('.mz-cart-count');
        if (badge) {
            badge.textContent = '0';
            badge.style.display = 'none';
        }
        const fcbItemCount = document.getElementById('fcb-item-count');
        if (fcbItemCount) fcbItemCount.textContent = '0 Items';
        const fcbPriceEl = document.getElementById('fcb-price');
        if (fcbPriceEl) fcbPriceEl.textContent = formatCents(0);
        const bar = document.getElementById('floating-cart-bar');
        if (bar) {
            bar.classList.remove('visible');
            document.body.classList.remove('has-floating-cart');
        }
        return;
    }

    const detailsHeader = document.querySelector('.cd-details-header');
    const progressSection = document.querySelector('.cd-progress-section');
    const priceSummary = document.querySelector('.cd-price-summary');
    const footer = document.querySelector('.cd-footer');
    const emptyState = document.querySelector('.cd-empty-state');

    if (detailsHeader) detailsHeader.style.display = '';
    if (progressSection) progressSection.style.display = '';
    if (priceSummary) priceSummary.style.display = '';
    if (footer) footer.style.display = '';
    if (emptyState) emptyState.style.display = 'none';

    const headerCount = document.querySelector('.cd-item-count');
    if (headerCount) {
        headerCount.textContent = regularItemsCount + (regularItemsCount === 1 ? ' Item' : ' Items');
    }
    const badge = document.querySelector('.mz-cart-count');
    if (badge) {
        badge.textContent = regularItemsCount;
        badge.style.display = regularItemsCount > 0 ? 'flex' : 'none';
    }
    const fcbItemCount = document.getElementById('fcb-item-count');
    if (fcbItemCount) {
        fcbItemCount.textContent = regularItemsCount + (regularItemsCount === 1 ? ' Item' : ' Items');
    }

    const mrpTotalEl = document.querySelector('.js-cd-mrp-total');
    if (mrpTotalEl) {
        mrpTotalEl.textContent = formatCents(originalTotalCents);
    }

    const discountEl = document.querySelector('.js-cd-discount');
    if (discountEl) {
        const discountVal = originalTotalCents - totalCents;
        discountEl.textContent = '-' + formatCents(discountVal);
    }

    const promoTotalRupees = promoTotalCents / 100.0;
    const shippingEl = document.querySelector('.js-cd-shipping');
    if (shippingEl) {
        if (promoTotalRupees >= freeShippingThreshold) {
            shippingEl.innerHTML = '<span class="cd-free">FREE</span>';
        } else {
            shippingEl.innerHTML = `<span>${formatCents(5000)}</span>`;
        }
    }

    const orderTotalEl = document.querySelector('.js-cd-order-total');
    if (orderTotalEl) {
        orderTotalEl.textContent = formatCents(totalCents);
    }

    const footerTotalEl = document.querySelector('.js-cd-footer-total');
    if (footerTotalEl) {
        footerTotalEl.textContent = formatCents(totalCents);
    }
    const footerOrigTotalEl = document.querySelector('.js-cd-footer-original-total');
    if (footerOrigTotalEl) {
        footerOrigTotalEl.textContent = formatCents(originalTotalCents);
    }

    const fcbPriceEl = document.getElementById('fcb-price');
    if (fcbPriceEl) {
        fcbPriceEl.textContent = formatCents(totalCents);
    }
    const fcbBar = document.getElementById('floating-cart-bar');
    if (fcbBar && regularItemsCount > 0) {
        fcbBar.classList.add('visible');
        document.body.classList.add('has-floating-cart');
    }

    updateMilestoneProgressUI(promoTotalRupees, freeShippingThreshold);
};

window.changeCartQty = function (key, newQty) {
    if (newQty < 0) return;

    cartUpdateError = null;

    const itemRow = document.querySelector(`.cd-item[data-key="${key}"], .cart-item[data-key="${key}"]`);
    if (itemRow) {
        const qtyVal = itemRow.querySelector('.cd-qty-val');
        const qtyInput = itemRow.querySelector('.qty-input');
        if (qtyVal) qtyVal.textContent = newQty;
        if (qtyInput) qtyInput.value = newQty;

        if (newQty === 0) {
            itemRow.style.pointerEvents = 'none';
            itemRow.style.transition = 'all 0.2s ease-out';
            itemRow.style.opacity = '0';
            itemRow.style.transform = 'scale(0.9)';
            setTimeout(() => {
                itemRow.style.display = 'none';
            }, 200);
        }
    }

    pendingQuantities[key] = newQty;

    window.mzOptimisticCartUpdate();

    if (cartUpdateTimeouts[key]) {
        clearTimeout(cartUpdateTimeouts[key]);
    }

    const delay = (newQty === 0) ? 50 : 150;

    cartUpdateTimeouts[key] = setTimeout(() => {
        const finalQty = pendingQuantities[key];
        delete pendingQuantities[key];
        delete cartUpdateTimeouts[key];

        activeCartFetches++;
        window.mzOptimisticCartUpdate();

        const rootUrl = window.Shopify?.routes?.root || '/';
        fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: finalQty })
        })
            .then(res => {
                return res.json().then(data => {
                    if (!res.ok) throw new Error(data.description || 'Error changing quantity');
                    return data;
                }).catch(() => {
                    if (!res.ok) throw new Error('Network response was not ok');
                    return {};
                });
            })
            .then(cart => {

                const badge = document.querySelector('.mz-cart-count');
                if (badge) {
                    badge.textContent = Math.max(0, cart.item_count);
                    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
                }

                if (typeof window.checkCartMilestones === 'function') {
                    window.checkCartMilestones(cart);
                }

                if (typeof window.updateCartDrawer === 'function') {
                    window.updateCartDrawer();
                }

                if (window.location.pathname.indexOf('/cart') !== -1) {
                    const doCartPageUpdate = () => {
                        fetch(rootUrl + '?section_id=main-cart')
                            .then(r => r.text())
                            .then(text => {
                                const temp = document.createElement('div');
                                temp.innerHTML = text;
                                const newCart = temp.querySelector('.cart-page-section');
                                const oldCart = document.querySelector('.cart-page-section');
                                if (newCart && oldCart) {
                                    oldCart.innerHTML = newCart.innerHTML;
                                }
                            });
                    };
                    if (finalQty === 0) {
                        setTimeout(doCartPageUpdate, 900);
                    } else {
                        doCartPageUpdate();
                    }
                }
            })
            .catch(err => {
                console.error(err);
                cartUpdateError = "Couldn't update cart, please try again";
                if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
            })
            .finally(() => {
                activeCartFetches--;
                window.mzOptimisticCartUpdate();
            });
    }, delay);
};

window.removeCartItem = function (key) {
    const item = document.querySelector(`.cd-item[data-key="${key}"]`) || document.querySelector(`.cart-item[data-key="${key}"]`);
    if (item) {
        item.style.pointerEvents = 'none';
    }
    window.changeCartQty(key, 0);
};

document.addEventListener('submit', function (e) {
    const form = e.target;

    const isCartAddForm = form.matches('form[action*="/cart/add"]') ||
        form.classList.contains('sb-form') ||
        form.classList.contains('card-form') ||
        form.classList.contains('ag-atc-form');

    if (!isCartAddForm) return;

    if (form.classList.contains('custom-kit-active')) return;

    const variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    if (!variantInput || !variantInput.value) {
        console.warn('[Moraze] No variant ID found in form — letting form submit natively');
        return;
    }

    e.preventDefault();

    const formData = new FormData(form);
    const submitBtn = form.querySelector('.sb-atc-btn') ||
        form.querySelector('button[type="submit"]') ||
        form.querySelector('.btn-add-to-cart');
    const originalHTML = submitBtn ? submitBtn.innerHTML : '';

    if (submitBtn) {
        submitBtn.innerHTML = '⏳ Adding...';
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.75';
    }

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        },
        body: formData
    })
        .then(function (response) {
            return response.json().then(function (data) {
                return { ok: response.ok, data: data };
            }).catch(function () {
                return { ok: response.ok, data: {} };
            });
        })
        .then(function (result) {
            if (!result.ok) {

                console.error('[Moraze] Add to cart failed:', result.data.description || result.data);
                alert(result.data.description || 'Could not add product to cart.');
                return;
            }

            if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
            if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
            if (typeof window.updateFloatingCartBar === 'function') window.updateFloatingCartBar();

            if (typeof window.checkCartMilestones === 'function') {

                setTimeout(() => window.checkCartMilestones(), 600);
            }
        })
        .catch(function (error) {
            console.error('[Moraze] Network error adding to cart:', error);
        })
        .finally(function () {
            if (submitBtn) {
                submitBtn.innerHTML = originalHTML || 'ADD TO CART';
                submitBtn.disabled = false;
                submitBtn.style.opacity = '1';
            }
        });
});

function initHeaderCart() {

    if (window.location.hash === '#cart-open') {
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        history.replaceState(null, null, ' ');
    }

    setTimeout(function () {
        if (typeof window.updateFloatingCartBar === 'function') {
            window.updateFloatingCartBar();
        }
    }, 300);
}

window.updateFloatingCartBar = function () {
    var bar = document.getElementById('floating-cart-bar');
    if (!bar) return;

    if (window.location.pathname.indexOf('/cart') !== -1) {
        bar.classList.remove('visible');
        document.body.classList.remove('has-floating-cart');
        return;
    }

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    fetch(rootUrl + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
            var countEl = document.getElementById('fcb-item-count');
            var priceEl = document.getElementById('fcb-price');

            if (cart.item_count > 0) {
                bar.classList.add('visible');
                document.body.classList.add('has-floating-cart');
                if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');
                if (priceEl) {
                    var symbol = (window.themeCurrency && window.themeCurrency.symbol) ? window.themeCurrency.symbol : '₹';
                    var isoCode = (window.themeCurrency && window.themeCurrency.isoCode) ? window.themeCurrency.isoCode : 'INR';
                    var dollars = cart.total_price / 100;
                    if (isoCode === 'INR') {
                        var rupees = Math.round(dollars);
                        priceEl.textContent = symbol + rupees.toLocaleString('en-IN');
                    } else {
                        priceEl.textContent = symbol + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    }
                }
            } else {
                bar.classList.remove('visible');
                document.body.classList.remove('has-floating-cart');
            }
        })
        .catch(function (e) { console.error('[Moraze] FCB update error:', e); });
};

window.updatePdpQty = function (change) {
    const qtyInput = document.getElementById('PdpQtyInput');
    if (!qtyInput) return;

    let currentQty = parseInt(qtyInput.value) || 1;
    let newQty = currentQty + change;

    if (newQty >= 1) {
        qtyInput.value = newQty;
    }
};

function initAccordions() {
    const headers = document.querySelectorAll('.accordion-header');
    headers.forEach(header => {
        header.addEventListener('click', function () {
            this.classList.toggle('active');

            const icon = this.querySelector('i');
            if (icon) {
                if (this.classList.contains('active')) {
                    icon.classList.remove('ph-caret-down');
                    icon.classList.add('ph-caret-up');
                } else {
                    icon.classList.remove('ph-caret-up');
                    icon.classList.add('ph-caret-down');
                }
            }

            const content = this.nextElementSibling;
            if (content) {
                if (content.style.display === 'block') {
                    content.style.display = 'none';
                } else {
                    content.style.display = 'block';
                }
            }
        });
    });
}

let lastActionTime = 0;
let touchStartX = 0;
let touchStartY = 0;
let touchStartTime = 0;
let touchButton = null;
let isScrollGesture = false;
let lastTouchTime = 0;

function handleTouchStart(e) {
    if (e.isTrusted === false) return;

    const selectors = '#AddToCart, .pdp-sticky-atc, .pdp-atc-btn, .sb-atc-btn, .ag-atc-btn';
    const btn = e.target.closest(selectors);
    if (!btn) return;

    const isLink = btn.tagName === 'A' || btn.closest('a');
    if (isLink) return;

    const form = btn.closest('form') || document.getElementById('AddToCartForm');
    const isCustomKit =
        document.querySelector('.ck-container[data-ck-managed]') !== null ||
        (form && form.classList.contains('custom-kit-active')) ||
        btn.hasAttribute('data-ck-managed');

    if (isCustomKit) return;

    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    touchButton = btn;
    isScrollGesture = false;
}

function handleTouchMove(e) {
    if (!touchButton) return;

    const diffX = Math.abs(e.touches[0].clientX - touchStartX);
    const diffY = Math.abs(e.touches[0].clientY - touchStartY);

    if (diffX > 10 || diffY > 10) {
        isScrollGesture = true;
        touchButton = null;
    }
}

function handleTouchEnd(e) {
    if (!touchButton) return;

    const duration = Date.now() - touchStartTime;
    const isTap = !isScrollGesture && duration < 500;

    if (isTap) {
        e.preventDefault();
        e.stopPropagation();

        const btn = touchButton;
        touchButton = null;

        const now = Date.now();
        if (now - lastActionTime < 1000) return;
        lastActionTime = now;
        lastTouchTime = now;

        const form = btn.closest('form') || document.getElementById('AddToCartForm');

        if (btn.classList.contains('pdp-sticky-atc')) {
            const mainForm = document.getElementById('AddToCartForm');
            if (mainForm) {
                mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
            return;
        }

        if (form) {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    } else {
        touchButton = null;
    }
}

function handleTouchCancel() {
    touchButton = null;
    isScrollGesture = false;
}

function handleBtnClick(e) {
    if (e.isTrusted === false) return;

    if (Date.now() - lastTouchTime < 800) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }

    const selectors = '#AddToCart, .pdp-sticky-atc, .pdp-atc-btn, .sb-atc-btn, .ag-atc-btn';
    const btn = e.target.closest(selectors);
    if (!btn) return;

    const isLink = btn.tagName === 'A' || btn.closest('a');
    if (isLink) return;

    const form = btn.closest('form') || document.getElementById('AddToCartForm');
    const isCustomKit =
        document.querySelector('.ck-container[data-ck-managed]') !== null ||
        (form && form.classList.contains('custom-kit-active')) ||
        btn.hasAttribute('data-ck-managed');

    if (isCustomKit) return;

    const now = Date.now();
    if (now - lastActionTime < 1000) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }

    e.stopPropagation();

    if (btn.classList.contains('pdp-sticky-atc')) {
        e.preventDefault();
        const mainForm = document.getElementById('AddToCartForm');
        if (mainForm) {
            lastActionTime = now;
            mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        return;
    }

    if (form) {
        e.preventDefault();
        lastActionTime = now;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
}

function initMobileTouchFix() {
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: false });
    document.addEventListener('touchcancel', handleTouchCancel, { passive: true });
}

function handleShadeSelectorScroll() {
    if (window.location.hash === '#shade-selector') {
        setTimeout(function () {
            const target = document.getElementById('shade-selector');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 500);
    }
}

document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]') || form.classList.contains('ag-atc-form')) {
        const card = form.closest('.ag-product-card');
        if (card) {
            const handle = card.getAttribute('data-product-handle');
            const template = card.getAttribute('data-product-template');
            if (template && ['custom-kit', 'foundation'].includes(template)) {
                if (window.location.pathname.indexOf('/products/' + handle) === -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = `/products/${handle}#shade-selector`;
                }
            }
        }
    }
}, true);

document.addEventListener('click', function (e) {

    handleBtnClick(e);

    var cartIcon = e.target.closest('.mz-cart-btn, #mzCartIcon, .mz-cart-icon, a[href="/cart"], a[href="/cart/"]');
    if (cartIcon) {
        e.preventDefault();
        if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
        }
        return;
    }

    var coinsBadge = e.target.closest('#mzCoinsHeaderBadge');
    if (coinsBadge) {
        e.preventDefault();
        const isEnabledInSettings = window.MorazeCoinsConfig?.enabled === true;
        const isBlockedByAdmin = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
        if (isEnabledInSettings && !isBlockedByAdmin) {
            var href = coinsBadge.getAttribute('href');
            if (href && href !== '#' && href.indexOf('javascript:') === -1 && href !== '') {
                window.location.href = href;
            } else {
                window.location.href = '/pages/my-moraze-coins';
            }
        } else {
            window.location.reload();
        }
        return;
    }

    const redirectBtn = e.target.closest('.ag-atc-btn, button[name="add"], .col-cta-btn');
    if (redirectBtn) {
        const card = redirectBtn.closest('.ag-product-card, .col-card');
        if (card) {
            const handle = card.getAttribute('data-product-handle');
            const template = card.getAttribute('data-product-template');
            if (template && ['custom-kit', 'foundation'].includes(template)) {
                if (window.location.pathname.indexOf('/products/' + handle) === -1) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = `/products/${handle}#shade-selector`;
                    return;
                }
            }
        }
    }

    const bubbleBtn = e.target.closest('.sb-atc-btn, .sb-notify-btn, .ag-atc-btn, .ag-notify-btn');
    if (bubbleBtn) {
        e.stopPropagation();
    }

    const card = e.target.closest('.product-card, .sb-product-card, .ag-product-card');
    if (card) {
        if (!e.target.closest('button') &&
            !e.target.closest('form') &&
            !e.target.closest('a') &&
            !e.target.closest('.sb-form') &&
            !e.target.closest('.sb-atc-btn') &&
            !e.target.closest('.ag-atc-btn') &&
            !e.target.closest('.sb-notify-btn') &&
            !e.target.closest('.ag-notify-btn') &&
            e.target.tagName !== 'BUTTON' &&
            e.target.tagName !== 'INPUT') {
            const link = card.querySelector('a');
            if (link && link.href && link.href !== '#' && !link.href.endsWith('#')) {
                window.location.href = link.href;
                return;
            }
        }
    }

    const bannerCard = e.target.closest('.wth-card-new');
    if (bannerCard) {
        if (!e.target.closest('form') && !e.target.closest('button') && !e.target.closest('a')) {
            const link = bannerCard.querySelector('.wth-card-btn');
            if (link && link.href && link.href !== '#' && !link.href.endsWith('#')) {
                window.location.href = link.href;
                return;
            }
        }
    }
});

(function () {
    'use strict';

    function getMilestonesConfig() {
        const el = document.getElementById('mz-milestones-data');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    let isProcessingCart = false;
    let lastKnownTotal = -1;
    let currentPopupMilestone = null;
    const shownMilestones = {};
    let isGiftAdding = false;
    const addedGiftIds = new Set();

    function showRewardPopup(milestone, cartData) {
        currentPopupMilestone = milestone;
        const popup = document.getElementById('mz-reward-popup');
        if (!popup) return;

        const variantId = parseInt(milestone.variantId, 10);
        if (addedGiftIds.has(variantId)) {
            console.log('[Moraze Milestones] Skipping popup show, gift already claimed:', variantId);
            return;
        }

        const imgEl = document.getElementById('mz-reward-img');
        const badgeEl = document.getElementById('mz-reward-badge');
        const linkEl = document.getElementById('mz-reward-link');
        const claimBtn = document.getElementById('mz-reward-claim');

        if (imgEl) {
            imgEl.src = milestone.image || '';
            imgEl.alt = milestone.label;
            imgEl.style.display = milestone.image ? 'block' : 'none';
        }
        if (badgeEl) {
            const lbl = (milestone.label || '').toUpperCase();
            badgeEl.textContent = lbl.startsWith('FREE') ? milestone.label : 'FREE ' + milestone.label;
        }
        if (linkEl) {
            if (milestone.productUrl) {
                linkEl.href = milestone.productUrl;
                linkEl.style.display = 'inline-block';
            } else {
                linkEl.style.display = 'none';
            }
        }

        if (claimBtn) {
            claimBtn.textContent = '🎁 Claim Free Gift';
            claimBtn.disabled = false;
        }

        if (cartData && cartData.items) {
            const hasGift = cartData.items.some(item =>
                item.variant_id === variantId && item.properties && item.properties._free_gift === 'true'
            );
            if (hasGift && claimBtn) {
                claimBtn.textContent = 'Already Added ✓';
                claimBtn.disabled = true;
            }
        }

        popup.classList.add('open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    window.closeRewardPopup = function () {
        const popup = document.getElementById('mz-reward-popup');
        if (popup) {
            popup.classList.remove('open');
            popup.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        }
    };

    window.addGiftToCart = async function (milestone) {
        if (!milestone) return;

        const variantId = parseInt(milestone.variantId, 10);
        if (!variantId) {
            console.warn('[Moraze Milestones] No variant ID on this milestone.');
            return;
        }

        if (isGiftAdding) {
            console.log('[Moraze Milestones] Gift add in progress, ignoring duplicate trigger.');
            return;
        }

        if (addedGiftIds.has(variantId)) {
            console.log('[Moraze Milestones] Gift already in claimed set:', variantId);
            window.closeRewardPopup();
            return;
        }

        isGiftAdding = true;

        const popupClaimBtn = document.getElementById('mz-reward-claim');
        const cfg = getMilestonesConfig();
        const milestoneIdx = cfg?.milestones?.findIndex(m => parseInt(m.variantId, 10) === variantId);
        let milestoneBarBtn = null;
        if (milestoneIdx !== undefined && milestoneIdx !== -1) {
            const node = document.querySelector(`.cd-node[data-milestone-index="${milestoneIdx}"]`);
            if (node) {
                milestoneBarBtn = node.querySelector('.claim-gift-btn');
            }
        }

        let popupOrigText = '';
        if (popupClaimBtn) {
            popupOrigText = popupClaimBtn.textContent;
            popupClaimBtn.textContent = 'Adding...';
            popupClaimBtn.disabled = true;
        }
        let barOrigText = '';
        if (milestoneBarBtn) {
            barOrigText = milestoneBarBtn.textContent;
            milestoneBarBtn.textContent = 'Adding...';
            milestoneBarBtn.disabled = true;
        }

        try {
            const rootUrl = window.Shopify?.routes?.root || '/';

            const hasGiftInDom = Array.from(document.querySelectorAll('.cd-item[data-is-free-gift="true"]')).some(row => {
                const key = row.getAttribute('data-key') || '';
                return key.toString().startsWith(variantId.toString());
            });

            if (hasGiftInDom) {
                console.log('[Moraze] Gift already in cart DOM.');
                addedGiftIds.add(variantId);
                window.closeRewardPopup();
                return;
            }

            const response = await fetch(rootUrl + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: {
                            '_free_gift': 'true',
                            'Gift Status': 'Unlocked'
                        }
                    }]
                })
            });
            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.description || data.message || 'Gift add nahi ho saka. Dobara try karein.'
                );
            }

            addedGiftIds.add(variantId);
            window.closeRewardPopup();
            if (milestoneBarBtn) {
                milestoneBarBtn.style.display = 'none';
            }

            if (typeof window.updateCartDrawer === 'function') {
                window.updateCartDrawer();
            }

        } catch (err) {
            console.error('[Moraze] addGiftToCart failed:', err.message);
            alert(err.message);
        } finally {
            isGiftAdding = false;

            if (!addedGiftIds.has(variantId)) {
                if (popupClaimBtn) {
                    popupClaimBtn.textContent = popupOrigText || '🎁 Claim Free Gift';
                    popupClaimBtn.disabled = false;
                }
                if (milestoneBarBtn) {
                    milestoneBarBtn.textContent = barOrigText || 'Claim';
                    milestoneBarBtn.disabled = false;
                }
            }
        }
    };

    window.confirmRewardGift = async function () {
        const milestone = currentPopupMilestone;
        if (milestone) {
            await window.addGiftToCart(milestone);
        }
    };

    window.claimRewardGift = async function () {
        const milestone = currentPopupMilestone;
        if (!milestone) {
            window.closeRewardPopup();
            return;
        }
        await window.addGiftToCart(milestone);
    };

    window.claimMilestoneGift = async function (blockIndex, btnElement) {
        const el = document.getElementById('mz-milestones-data');
        if (!el) return;
        let cfg;
        try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
        if (!cfg || !cfg.milestones || !cfg.milestones[blockIndex]) return;
        const milestone = cfg.milestones[blockIndex];
        currentPopupMilestone = milestone;
        await window.addGiftToCart(milestone);
    };

    function updateCartIndicators() {
        const rootUrl = window.Shopify?.routes?.root || '/';
        fetch(rootUrl + 'cart.js')
            .then(res => res.json())
            .then(cart => {
                const badge = document.querySelector('.mz-cart-count');
                if (badge) {
                    badge.textContent = cart.item_count;
                    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
                }
                if (typeof window.updateFloatingCartBar === 'function') {
                    window.updateFloatingCartBar();
                }
            })
            .catch(e => console.error('[Moraze Milestones] Error updating indicators:', e));
    }

    function syncMilestoneGifts(cart) {
        if (!cart || !cart.items) return Promise.resolve(false);
        const cfg = getMilestonesConfig();
        console.log('[Moraze Milestones] Sync config:', cfg);
        if (!cfg || !cfg.milestones || cfg.milestones.length === 0) {
            console.warn('[Moraze Milestones] No milestones configuration found on this page.');
            return Promise.resolve(false);
        }

        let baseTotal = 0;
        let regularCount = 0;
        cart.items.forEach(item => {
            const isGift = item.properties && item.properties._free_gift === 'true';
            if (!isGift) {
                baseTotal += item.final_line_price;
                regularCount += item.quantity;
            }
        });
        const baseTotalRupees = baseTotal / 100;
        console.log('[Moraze Milestones] Base cart total (excluding gifts): ₹' + baseTotalRupees + ', regular items: ' + regularCount);

        const itemsToAdd = [];
        const itemsToRemove = [];

        if (regularCount === 0 && cart.items.length > 0) {
            cart.items.forEach(item => {
                const isGift = item.properties && item.properties._free_gift === 'true';
                if (isGift) {
                    console.log('[Moraze Milestones] Regular items total 0, queueing free gift to REMOVE from server:', item.title);
                    itemsToRemove.push(item.key);
                }
            });
        } else if (cfg && cfg.milestones) {
            cfg.milestones.forEach(m => {
                const variantId = parseInt(m.variantId, 10);
                if (!variantId) return;

                const hasGiftInCart = cart.items.some(item => {
                    return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
                });

                const isEligible = baseTotalRupees >= m.threshold;
                if (isEligible && !hasGiftInCart) {
                    console.log('[Moraze Milestones] Gift eligible but not in cart. Requires manual claim.');
                } else if (!isEligible && hasGiftInCart) {
                    const giftItem = cart.items.find(item => {
                        return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
                    });
                    if (giftItem) {
                        console.log('[Moraze Milestones] Queueing gift to REMOVE:', m.label);
                        itemsToRemove.push(giftItem.key);
                    }
                }
            });
        }

        if (itemsToRemove.length === 0 && itemsToAdd.length === 0) {
            console.log('[Moraze Milestones] No changes needed (all gifts in sync).');
            return Promise.resolve(false);
        }

        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        let promise = Promise.resolve();

        itemsToRemove.forEach(key => {
            promise = promise.then(() => {
                console.log('[Moraze Milestones] Removing gift key:', key);
                return fetch(rootUrl + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ id: key, quantity: 0 })
                }).catch(e => console.error('[Moraze Milestones] Error removing gift:', e));
            });
        });

        if (itemsToAdd.length > 0) {
            promise = promise.then(() => {
                console.log('[Moraze Milestones] Adding gifts payload:', itemsToAdd);
                return fetch(rootUrl + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ items: itemsToAdd })
                }).catch(e => console.error('[Moraze Milestones] Error adding gift:', e));
            });
        }

        return promise.then(() => {
            console.log('[Moraze Milestones] Cart sync updates completed.');
            return true;
        });
    }

    window.checkCartMilestones = function (cartData = null) {
        if (isProcessingCart) return;
        isProcessingCart = true;

        console.log('[Moraze Milestones] Running checkCartMilestones...');
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

        let cartPromise;
        if (cartData) {
            cartPromise = Promise.resolve(cartData);
        } else {
            cartPromise = fetch(rootUrl + 'cart.js').then(res => res.json());
        }

        cartPromise.then(cart => {
            // Sync addedGiftIds from cart items
            addedGiftIds.clear();
            if (cart && cart.items) {
                cart.items.forEach(item => {
                    if (item.properties && item.properties._free_gift === 'true') {
                        addedGiftIds.add(item.variant_id);
                    }
                });
            }

            let baseTotal = 0;
            if (cart && cart.items) {
                cart.items.forEach(item => {
                    const isGift = item.properties && item.properties._free_gift === 'true';
                    if (!isGift) baseTotal += item.final_line_price;
                });
            }
            const baseTotalRupees = baseTotal / 100;

            updateCartIndicators();

            const cfg = getMilestonesConfig();
            if (!cfg || !cfg.milestones || cfg.milestones.length === 0) {
                console.warn('[Moraze Milestones] Milestones config is missing or empty.');
                isProcessingCart = false;
                return;
            }

            if (baseTotalRupees !== lastKnownTotal) {
                const prevTotal = lastKnownTotal;
                lastKnownTotal = baseTotalRupees;

                cfg.milestones.forEach(m => {
                    if (baseTotalRupees < m.threshold && shownMilestones[m.variantId]) {
                        delete shownMilestones[m.variantId];
                        console.log('[Moraze Milestones] Reset shown state for milestone (total dropped):', m.label);
                    }
                });

                const newlyUnlocked = cfg.milestones.filter(m => {
                    const variantId = parseInt(m.variantId, 10);
                    const hasGiftInCart = cart.items.some(item => {
                        return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
                    });

                    if (hasGiftInCart || shownMilestones[m.variantId]) {
                        return false;
                    }

                    const justCrossed = prevTotal >= 0 && prevTotal < m.threshold && baseTotalRupees >= m.threshold;

                    const initialLoadEligible = prevTotal === -1 && baseTotalRupees >= m.threshold;

                    return justCrossed || initialLoadEligible;
                });

                if (newlyUnlocked.length > 0) {
                    newlyUnlocked.sort((a, b) => b.threshold - a.threshold);
                    const top = newlyUnlocked[0];
                    console.log('[Moraze Milestones] Showing popup for milestone:', top.label);

                    showRewardPopup(top, cart);

                    newlyUnlocked.forEach(m => {
                        shownMilestones[m.variantId] = true;
                    });
                }
            }

            return syncMilestoneGifts(cart).then(changed => {
                if (changed) {
                    console.log('[Moraze Milestones] Cart changed, updating cart drawer DOM...');
                    isProcessingCart = false;
                    if (typeof window.updateCartDrawer === 'function') {
                        window.updateCartDrawer();
                    }
                }
            });

        }).catch(error => {
            console.error('[Moraze Milestones] Error in checkCartMilestones:', error);
        }).finally(() => {
            isProcessingCart = false;
        });
    };

    function initMilestones() {
        const closeBtn = document.getElementById('mz-reward-close');
        const continueBtn = document.getElementById('mz-reward-continue');
        const popup = document.getElementById('mz-reward-popup');

        if (closeBtn) {
            closeBtn.removeEventListener('click', window.closeRewardPopup);
            closeBtn.addEventListener('click', window.closeRewardPopup);
        }
        if (continueBtn) {
            continueBtn.removeEventListener('click', window.confirmRewardGift);
            continueBtn.addEventListener('click', window.confirmRewardGift);
        }
        if (popup) {
            popup.addEventListener('click', e => {
                if (e.target === popup) window.closeRewardPopup();
            });
        }

        window.checkCartMilestones();
    }

    window.initMilestones = initMilestones;

    document.addEventListener('cart-drawer:updated', () => {
        if (typeof window.checkCartMilestones === 'function') {
            window.checkCartMilestones();
        }
        if (typeof window.populateCartDeals === 'function') {
            window.populateCartDeals();
        }
    });
})();

window.mzAdminAddGiftBlock = async function (blockIndex) {
    const cfgEl = document.getElementById('mz-milestones-data');
    if (!cfgEl) { alert('Milestone config not found on this page.'); return; }
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { alert('Config parse error.'); return; }

    const milestone = cfg.milestones && cfg.milestones[blockIndex];
    if (!milestone) { alert('Milestone block #' + blockIndex + ' not found.'); return; }

    const btn = event && event.target;
    const origText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = '⏳ Adding...'; btn.disabled = true; }

    const variantId = parseInt(milestone.variantId, 10);
    if (!variantId) {
        alert('Could not find a valid variant ID for "' + milestone.label + '". Please make sure a product is selected in the block settings.');
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        return;
    }

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    try {
        const response = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                        '_free_gift': 'true',
                        'Gift Status': 'Manual'
                    }
                }]
            })
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.description || 'Could not add manual gift.');
        }

        if (typeof window.updateCartDrawer === 'function') {
            window.updateCartDrawer();
        }
    } catch (error) {
        console.error('[Moraze Admin] Error adding manual gift:', error);
        alert('Error adding gift: ' + error.message);
    } finally {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
    }
};

function initTrustooCardsObserver() {
    if (!document.querySelector('.ag-product-card')) return;

    function getReviewsFallback(title, handle) {
        title = (title || '').toLowerCase();
        handle = (handle || '').toLowerCase();

        if (title.indexOf('4 trending') !== -1 || handle.indexOf('4-trending') !== -1) {
            return null;
        }

        if (title.indexOf('3 ultra soft') !== -1 || handle.indexOf('3-ultra-soft') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        if (title.indexOf('4 glamorous') !== -1 || handle.indexOf('4-glamorous') !== -1) {
            return { rating: 4.9, count: "350+" };
        }
        if (title.indexOf('4 must-have') !== -1 || handle.indexOf('4-must-have') !== -1) {
            return { rating: 4.8, count: "300+" };
        }
        if (title.indexOf('4 ultra soft') !== -1 || handle.indexOf('4-ultra-soft') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        if (title.indexOf('lipstick kit') !== -1 || handle.indexOf('lipstick-kit') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        return null;
    }

    function updateCardElement(card) {
        var hiddenWidget = card.querySelector('.trustoo-hidden-card-widget');
        if (!hiddenWidget) return false;

        var text = hiddenWidget.textContent.trim();
        var title = (card.dataset.productTitle || '').toLowerCase();
        var handle = (card.dataset.productHandle || '').toLowerCase();
        var fallback = getReviewsFallback(title, handle);

        if (!text) {

            if (fallback) {
                var ratingValEl = card.querySelector('.ag-card-rating-val');
                var countEls = card.querySelectorAll('.ag-card-reviews-count');
                var ratingRow = card.querySelector('.ag-card-rating-row');

                if (ratingValEl) ratingValEl.textContent = fallback.rating.toFixed(1);
                if (countEls.length > 0) {
                    countEls.forEach(function (el) {
                        el.textContent = fallback.count;
                    });
                }
                if (ratingRow) {
                    ratingRow.style.setProperty('display', 'flex', 'important');
                }
                card.dataset.trustooProcessed = "true";
                return true;
            }

            var ratingRow = card.querySelector('.ag-card-rating-row');
            var countEl = card.querySelector('.ag-card-reviews-count');
            var initialCount = countEl ? parseInt(countEl.textContent, 10) : 0;
            if ((isNaN(initialCount) || initialCount === 0) && ratingRow) {
                ratingRow.style.setProperty('display', 'none', 'important');
            }
            return false;
        }

        if (card.dataset.trustooProcessed === "true") return true;

        var numbers = text.match(/\d+(\.\d+)?/g) || [];
        if (numbers.length === 0) return false;

        var countMatch = text.match(/\((\d+)\)/);
        var reviewWordMatch = text.match(/(\d+)\s*(?:reviews?|customer reviews?)/i);
        var count = null;
        if (countMatch) {
            count = parseInt(countMatch[1]);
        } else if (reviewWordMatch) {
            count = parseInt(reviewWordMatch[1]);
        }

        var parsedNumbers = [];
        for (var i = 0; i < numbers.length; i++) {
            parsedNumbers.push({
                val: parseFloat(numbers[i]),
                str: numbers[i],
                hasDot: numbers[i].indexOf('.') !== -1
            });
        }

        for (var i = 0; i < parsedNumbers.length; i++) {
            if (parsedNumbers[i].val > 5.0) {
                if (count === null) {
                    count = Math.round(parsedNumbers[i].val);
                }
            }
        }

        if (count !== null) {
            for (var i = 0; i < parsedNumbers.length; i++) {
                if (Math.round(parsedNumbers[i].val) === count) {
                    parsedNumbers.splice(i, 1);
                    break;
                }
            }
        }

        var rating = null;

        if (parsedNumbers.length > 0) {

            var decimalRating = null;
            for (var i = 0; i < parsedNumbers.length; i++) {
                var p = parsedNumbers[i];
                if (p.hasDot && p.val >= 1.0 && p.val <= 5.0) {
                    decimalRating = p.val;
                    break;
                }
            }

            if (decimalRating !== null) {
                rating = decimalRating;
            } else {

                var normalRating = null;
                for (var i = 0; i < parsedNumbers.length; i++) {
                    var p = parsedNumbers[i];
                    if (p.val >= 1.0 && p.val <= 5.0) {
                        normalRating = p.val;
                        break;
                    }
                }
                if (normalRating !== null) {
                    rating = normalRating;
                } else {

                    if (parsedNumbers[0].val <= 5.0) {
                        rating = parsedNumbers[0].val;
                    }
                }
            }
        }

        if (count === null) {
            if (rating !== null) {
                for (var i = 0; i < parsedNumbers.length; i++) {
                    if (parsedNumbers[i].val === rating) {
                        parsedNumbers.splice(i, 1);
                        break;
                    }
                }
            }
            if (parsedNumbers.length > 0) {
                count = Math.round(parsedNumbers[0].val);
            } else if (rating !== null && /reviews?/i.test(text)) {
                count = Math.round(rating);
                rating = null;
            }
        }

        if (rating === null) {
            var ratingValEl = card.querySelector('.ag-card-rating-val');
            if (ratingValEl) {
                var currentRating = parseFloat(ratingValEl.textContent);
                if (!isNaN(currentRating) && currentRating > 1.0 && currentRating <= 5.0) {
                    rating = currentRating;
                } else if (count > 0) {
                    rating = 5.0;
                }
            }
        }

        if (rating !== null && !isNaN(rating)) {
            if (rating <= 1.0 || rating > 5.0) {
                if (count > 0) {
                    rating = 5.0;
                } else {
                    rating = 4.9;
                }
            }
        }

        if ((rating === null || count === 0) && fallback) {
            rating = fallback.rating;
            count = fallback.count;
        }

        if (rating === null) {
            return false;
        }

        var ratingValEl = card.querySelector('.ag-card-rating-val');
        var countEls = card.querySelectorAll('.ag-card-reviews-count');
        var ratingRow = card.querySelector('.ag-card-rating-row');

        if (ratingValEl) {
            ratingValEl.textContent = rating.toFixed(1);
        }
        if (count !== null && count !== undefined && countEls.length > 0) {
            countEls.forEach(function (el) {
                el.textContent = count;
            });
            var hasCount = false;
            if (typeof count === 'string') {
                hasCount = count.trim().length > 0 && count !== '0';
            } else {
                hasCount = !isNaN(count) && count > 0;
            }
            if (hasCount && ratingRow) {
                ratingRow.style.setProperty('display', 'flex', 'important');
            } else if (ratingRow) {
                ratingRow.style.setProperty('display', 'none', 'important');
            }
        }

        card.dataset.trustooProcessed = "true";
        return true;
    }

    document.querySelectorAll('.ag-product-card').forEach(updateCardElement);

    const catalogContainer = document.querySelector('.main-content, #MainContent');
    if (catalogContainer) {
        let isScheduled = false;
        const pendingCards = new Set();

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                let node = mutation.target;
                if (node && node.nodeType === Node.TEXT_NODE) {
                    node = node.parentElement;
                }
                if (node && node.closest) {
                    const widget = node.closest('.trustoo-hidden-card-widget');
                    if (widget) {
                        const card = widget.closest('.ag-product-card');
                        if (card && card.dataset.trustooProcessed !== "true") {
                            pendingCards.add(card);
                        }
                    }
                }
            });

            if (pendingCards.size > 0 && !isScheduled) {
                isScheduled = true;
                requestAnimationFrame(() => {
                    pendingCards.forEach(card => updateCardElement(card));
                    pendingCards.clear();
                    isScheduled = false;
                });
            }
        });

        observer.observe(catalogContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }
}

window.mzAdminToggleCoinsStatus = function () {
    const isBlocked = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
    const nextStatus = !isBlocked;
    localStorage.setItem('moraze_coins_disabled_globally', nextStatus ? 'true' : 'false');

    const btn = document.getElementById('mz-admin-coins-toggle');
    if (btn) {
        btn.textContent = nextStatus ? '🔴 Coins: BLOCKED (Click to Unblock)' : '🟢 Coins: ACTIVE (Click to Block)';
        btn.style.background = nextStatus ? '#fef2f2' : '#ecfdf5';
        btn.style.color = nextStatus ? '#dc2626' : '#059669';
        btn.style.borderColor = nextStatus ? '#fca5a5' : '#a7f3d0';
    }

    const widgets = document.querySelectorAll('#moraze-coins-cart-root, #moraze-coins-widget, .mc-cart-widget, #moraze-coins-redeem-widget, #moraze-coins-account-root, .moraze-coins-tab-wrapper, .moraze-wallet-card, .sb-coins-card, .mz-wallet-section');
    widgets.forEach(w => {
        w.style.display = nextStatus ? 'none' : '';
    });

    const rootUrl = window.Shopify?.routes?.root || '/';
    fetch(rootUrl + 'apps/moraze-coins/api/toggle-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            admin_id: window.MorazeCoinsConfig?.customerId || 'admin',
            blocked: nextStatus
        })
    }).catch(e => console.warn('Mock toggle sync failed:', e));

    setTimeout(() => {
        window.location.reload();
    }, 600);
};

window.mzAdminInitCoinsToggle = function () {

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('admin_mode') === 'true') {
        localStorage.setItem('mz_admin_mode', 'true');
    } else if (urlParams.get('admin_mode') === 'false') {
        localStorage.removeItem('mz_admin_mode');
    }

    const hasAdminTags = window.MorazeCoinsConfig?.isAdmin === true;
    const isDesignMode = (window.Shopify && window.Shopify.designMode === true) || window.location.href.indexOf('design_mode=true') !== -1;
    const isLocalStorageAdmin = localStorage.getItem('mz_admin_mode') === 'true';

    const showAdminPanel = hasAdminTags || isDesignMode || isLocalStorageAdmin;
    const adminPanel = document.getElementById('mz-admin-gift-panel');
    if (adminPanel) {
        adminPanel.style.display = showAdminPanel ? 'block' : 'none';
    }

    const isBlocked = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
    const btn = document.getElementById('mz-admin-coins-toggle');
    if (btn) {
        btn.textContent = isBlocked ? '🔴 Coins: BLOCKED (Click to Unblock)' : '🟢 Coins: ACTIVE (Click to Block)';
        btn.style.background = isBlocked ? '#fef2f2' : '#ecfdf5';
        btn.style.color = isBlocked ? '#dc2626' : '#059669';
        btn.style.borderColor = isBlocked ? '#fca5a5' : '#a7f3d0';
    }

    if (isBlocked) {
        const widgets = document.querySelectorAll('#moraze-coins-cart-root, #moraze-coins-widget, .mc-cart-widget, #moraze-coins-redeem-widget, #moraze-coins-account-root, .moraze-coins-tab-wrapper, .moraze-wallet-card, .sb-coins-card, .mz-wallet-section');
        widgets.forEach(w => {
            w.style.display = 'none';
        });
    }

    const coinsBadgeEl = document.getElementById('mzCoinsHeaderBadge');
    if (coinsBadgeEl) {
        coinsBadgeEl.style.visibility = isBlocked ? 'hidden' : 'visible';
    }
};

function initializeDOM() {
    initTheme();
    initHeaderCart();
    initAccordions();
    initMobileTouchFix();
    handleShadeSelectorScroll();
    if (typeof window.initMilestones === 'function') {
        window.initMilestones();
    }
    if (typeof window.mzAdminInitCoinsToggle === 'function') {
        window.mzAdminInitCoinsToggle();
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDOM);
} else {
    initializeDOM();
}

document.addEventListener('cart-drawer:updated', window.mzAdminInitCoinsToggle);
